/** @file Grid tick spacing: the smallest 1, 2 or 5 × 10^k step at least minPx pixels apart. */

/** Step in axis units for an axis drawn at pxPerUnit; `whole` rounds to whole units (frames), never below 1. */
export function curveTickStep(pxPerUnit: number, minPx: number, whole: boolean): number {
  const raw = minPx / pxPerUnit;
  const pow = 10 ** Math.floor(Math.log10(raw));
  const step = [1, 2, 5].map((m) => m * pow).find((s) => s >= raw) ?? 10 * pow;
  return whole ? Math.max(1, Math.round(step)) : step;
}
